var API_VERSION = 'v0';
var TTT_VERSION = '0.0.0';
export default (function (constants) {
    API_VERSION = constants.API_VERSION;
    TTT_VERSION = constants.TTT_VERSION;
});
var PARAM_REGEX = /^(sc_|fbclid|gclid|msclkid|nwt_nav)/;
var NWT_TRACKING_PATH = '/api/unified-underdog';
export { API_VERSION, TTT_VERSION, PARAM_REGEX, NWT_TRACKING_PATH };
